export enum SeasonOfficialsTableFilters {
  Role = "role",
  Status = "status",
}
